import { __exports as CODE128C } from "./index207.js";
import { __require as requireCODE128 } from "./index202.js";
import { __require as requireConstants } from "./index205.js";
var hasRequiredCODE128C;
function requireCODE128C() {
  if (hasRequiredCODE128C) return CODE128C;
  hasRequiredCODE128C = 1;
  Object.defineProperty(CODE128C, "__esModule", {
    value: true
  });
  var _createClass = /* @__PURE__ */ (function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  })();
  var _CODE2 = requireCODE128();
  var _CODE3 = _interopRequireDefault(_CODE2);
  var _constants = requireConstants();
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var CODE128C$1 = (function(_CODE) {
    _inherits(CODE128C2, _CODE);
    function CODE128C2(string, options) {
      _classCallCheck(this, CODE128C2);
      return _possibleConstructorReturn(this, (CODE128C2.__proto__ || Object.getPrototypeOf(CODE128C2)).call(this, _constants.C_START_CHAR + string, options));
    }
    _createClass(CODE128C2, [{
      key: "valid",
      value: function valid() {
        return new RegExp("^" + _constants.C_CHARS + "+$").test(this.data);
      }
    }]);
    return CODE128C2;
  })(_CODE3.default);
  CODE128C.default = CODE128C$1;
  return CODE128C;
}
export {
  requireCODE128C as __require
};
//# sourceMappingURL=index163.js.map
